import UserService from '../services/user.service';
// import { getSavedState, saveState, removeState } from '../utils/localstorage';
import { parseDateForUser } from '../utils/date';


export const user = {
  namespaced: true,
  state: { 
    userList: [],
    isLoading: false
  },
  actions: {
    async createNewUser({ dispatch }, user) {
      const resp = await UserService.createNewUser(user);
      if (resp.status === 200) dispatch('getUserList');
      return resp.status;
    },

    async createNewUserPublic(_, user) {
      const resp = await UserService.createNewUserPublic(user);
      return resp.status;
    },

    async changeUserData(_, userData) { 
      const resp = await UserService.putUserData(userData);
      return resp.status;
    },
    async changeUserPassword(_, passwords) {
      const resp = await UserService.putUserPassword(passwords);
      return resp.status;
    },
    async getUserList({ commit }) {
      commit('SET_IS_LOADING', true);
      const resp = await UserService.getUserList();
      commit('SET_USER_LIST', resp.data);
      commit('SET_IS_LOADING', false);
      return resp.status;
    },
    async getUserById(_, idUsuario) {
      const resp = await UserService.getUserById(idUsuario);
      if (resp.status === 200) {
        const user = resp.data;
        if(user.assinaturasList){
          user.assinaturasList.map(v => {
            v.dataAssinatura = parseDateForUser(v.dataAssinatura);
            v.dataVencimento = parseDateForUser(v.dataVencimento);
             return v
          })
        }
        return user
      }
      return resp.status;
    },
    async deleteUser(_, idUsuario) {
      const resp = await UserService.deleteUser(idUsuario);
      return resp.status;
    },
    async recoverPassword(_, email) {
      const resp = await UserService.recoverPassword(email);
      return resp.status;
    },
    async newPassword(_, request) {
      const resp = await UserService.newPassword(request);
      if(resp){
        return resp.status
      }else{
        return 500
      }
    },
  },
  mutations: {
    SET_USER_LIST(state, list) {
      state.userList = [...list];
    },
    SET_IS_LOADING(state, isLoading) {
      state.isLoading = isLoading;
    },
  },
};
